import { Route } from 'react-router'
import { observer } from 'mobx-react-lite'
import { RoutesWithNotFound } from 'entities/ExportRouters/ui/RoutesWithNotFound'
import { TagsPage } from 'pages/settings/pages/tags'
import { TaggedContactsPage } from 'pages/settings/pages/tags/ui/TaggedContactsPage/TaggedContactsPage'

export const TagsRouter = observer(() => {
  return (
    <RoutesWithNotFound>
      <Route index element={<TagsPage />} />
      <Route path={':id'} element={<TaggedContactsPage />} />
    </RoutesWithNotFound>
  )
})
